var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.126 16.8215L14.7619 12.5556C14.8366 12.4869 14.8965 12.4016 14.9376 12.3056C14.9787 12.2096 15 12.1052 15 11.9996C15 11.894 14.9787 11.7896 14.9376 11.6936C14.8965 11.5976 14.8366 11.5123 14.7619 11.4436L10.126 7.17768C9.6835 6.77056 9 7.1081 9 7.73373L9 16.2667C9 16.8923 9.6835 17.2299 10.126 16.8215Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminNext);
export default __webpack_public_path__ + "static/media/ic_admin_next.b9ab7035990f5969af3b718d6cdac2a0.svg";
export { ForwardRef as ReactComponent };